export default function () {
  const page = document.querySelector('.PageMain--category-landing .Cyberweek')

  if (!page) {
    return
  }

  const anchorLinks = Array.from(page.querySelectorAll('a'))

  anchorLinks.forEach((anchorLink) => {
    anchorLink.addEventListener('click', function (e) {
      const elementHash = this.hash ? document.querySelector(this.hash) : null

      if (elementHash) {
        e.preventDefault()

        const scrollPosition = elementHash.offsetTop

        window.scrollTo({
          top: scrollPosition,
          left: 0,
          behavior: 'smooth',
        })
      }
    })
  })
}
